import { AnyDevice, DeviceAssignedToOrganisation } from '@/types/device';

export const isDeviceAssigned = (
  device: AnyDevice,
): device is DeviceAssignedToOrganisation =>
  'organisation' in device && device.organisation !== undefined;
